import {
    ACTIVE_ACCOUNTS,
    PRIME_ACCOUNT,
    MEMBERSHIP_TYPE,
    MEMBERSHIP_ACCOUNT_TYPE,
    MEMBERSHIP_DURATION_UNIT,
} from 'od-modules/utils/membership_constants';

const highlightedFeePaymentMethods = ['SOFORT', 'PAYPAL'];
const ACTIVATED = 'ACTIVATED';

function getMembershipType() {
    const {isMembershipFreeTrial, isPrimeMobile} = Odigeo.Membership;
    if (isMembershipFreeTrial || isPrimeMobile) {
        return MEMBERSHIP_TYPE.FREE_TRIAL;
    }
    return MEMBERSHIP_TYPE.DEFAULT;
}

function isAccountActive(userStatus) {
    return Object.values(ACTIVE_ACCOUNTS).filter((statusAccount) => statusAccount === userStatus).length > 0;
}

function isPrimeAccount(userStatus) {
    return userStatus === PRIME_ACCOUNT;
}

function translateBooleanToString(options) {
    return Odigeo._.mapValues(options, (value) => {
        return value ? 'T' : 'F';
    });
}

function isMembershipAdded(membershipDTO) {
    return isMembershipStatusActivated(membershipDTO) && !!membershipDTO.isIncludedInPrice;
}

function getResultFullFareSelected(defaultValue = true) {
    const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
    return Odigeo.SessionScope.flowProduct === 'dp'
        ? Odigeo.Utils.parseJson(Odigeo.Session.get('isDpNonPrimePriceSelected'))
        : Odigeo._.get(flightSelectionData, 'data.priceWithoutDiscountSelected', defaultValue);
}

function isFreeTrialMembership(membershipType, {monthsDuration, duration, durationTimeUnit}, totalPrice) {
    return (
        membershipType === MEMBERSHIP_ACCOUNT_TYPE.BASIC &&
        (monthsDuration === 1 ||
            (durationTimeUnit === MEMBERSHIP_DURATION_UNIT.MONTHS && duration === 1) ||
            durationTimeUnit === MEMBERSHIP_DURATION_UNIT.DAYS) &&
        !totalPrice
    );
}

function isMembershipStatusActivated(membershipDTO) {
    return Odigeo._.isObject(membershipDTO) && membershipDTO.status === ACTIVATED;
}

export {
    translateBooleanToString,
    getMembershipType,
    isAccountActive,
    isMembershipAdded,
    getResultFullFareSelected,
    isPrimeAccount,
    highlightedFeePaymentMethods,
    isFreeTrialMembership,
    isMembershipStatusActivated,
};
